import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { getUserText } from 'ziphy-web-shared/basic/helpers';
import { CustomLink } from 'ziphy-web-shared/basic/lib/buttons';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $layouts } from 'ziphy-web-shared/basic/utils/layouts';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { $time, formatDate, getGreeting } from 'ziphy-web-shared/basic/utils/time';
import $livequeueConsultationsStore from '@core/src/store/livequeueConsultationsStore';
import { $calendar } from '@nedoShared/modules/calendar/Calendar.store';
import { $notices } from '@store';
import { apptStatuses } from '@config/apptsCore';
import styles from './DashboardHeader.module.scss';
const DashboardHeader = ({ onChange, field }) => {
    var _a, _b;
    const profile = $auth.user;
    const { t } = useTranslation();
    const now = moment.tz($calendar.timezone);
    const today = now.clone().startOf('day');
    const handleChange = (value) => {
        var _a;
        (_a = field.onChange) === null || _a === void 0 ? void 0 : _a.call(field, value);
        onChange({ search: value });
    };
    const unreadNotifications = (_b = (_a = $notices.notViewedItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    const [apptCount, setApptCount] = useState(0);
    useEffect(() => {
        if (!$calendar.appointments) {
            setApptCount(0);
            return;
        }
        const localTZ = $calendar.timezone;
        const count = Object.values($calendar.appointments).filter((a) => {
            const start = moment.tz(a.appointedStart, localTZ);
            const isToday = start.isSame(today, 'day');
            const isActive = apptStatuses.isActive
                ? apptStatuses.isActive(a.status)
                : Array.isArray(apptStatuses.active) &&
                    apptStatuses.active.includes(a.status);
            return isToday && isActive;
        }).length;
        setApptCount(count);
    }, [$calendar.appointments, $calendar.selectedDay]);
    useEffect(() => {
        $livequeueConsultationsStore.getActiveConsultations();
    }, []);
    const greeting = getGreeting();
    const name = getUserText(profile, ['fullName']);
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper) }, { children: [_jsx("div", Object.assign({ className: styles.title }, { children: $windowSize.isXS ? (_jsxs(_Fragment, { children: [_jsxs("div", { children: [greeting, ","] }), _jsx("div", { children: name })] })) : (`${greeting}, ${name}`) })), _jsx("div", Object.assign({ className: styles.time }, { children: formatDate($time.now, 'time') })), _jsxs("div", Object.assign({ className: styles.agenda }, { children: [_jsx("div", Object.assign({ className: styles.agendaTitle }, { children: t('dashboard.header.todays_agenda') })), apptCount > 0 && (_jsx(CustomLink, Object.assign({ autoTarget: {
                            to: $router.toPath('appts', {
                                query: {
                                    view: 'current',
                                    dateFrom: today.clone().startOf('day').toISOString(),
                                    dateTo: today.clone().endOf('day').toISOString(),
                                },
                            }),
                        }, className: styles.agendaItem }, { children: `${apptCount} ${t('dashboard.header.telehealth_scheduled_today')}` }))), $livequeueConsultationsStore.activeConsultations.length > 0 && (_jsx(CustomLink, Object.assign({ autoTarget: {
                            to: $router.toPath('consultations', {
                                query: {
                                    tab: 'active',
                                },
                            }),
                        }, className: styles.agendaItem }, { children: t('dashboard.header.active_consultations', {
                            count: $livequeueConsultationsStore.activeConsultations.length,
                        }) }))), _jsx("div", Object.assign({ onClick: () => {
                            if (unreadNotifications > 0) {
                                $layouts.showRightSidebar('notifications', {});
                            }
                        }, className: clsx(styles.agendaItem, {
                            [styles.agendaItemDisabled]: unreadNotifications === 0,
                        }) }, { children: unreadNotifications > 0
                            ? `${unreadNotifications} ${t('dashboard.header.unread_notifications')}`
                            : t('dashboard.header.no_unread_notifications') }))] })), _jsx("div", Object.assign({ className: styles.search }, { children: _jsx(Input, { field: Object.assign(Object.assign({}, field), { onChange: handleChange }), placeholder: t('text.dashboard.ph.search'), leftElement: 'search', className: styles.search, mode: ['sm', 'gray'], clear: true, clearedValue: '' }) }))] })));
};
export default observer(DashboardHeader);
